import Component from '@glimmer/component';
import AditoolsMenuTab from './aditools-menu-tab.ts';

interface AditoolsMenuTabsSignature {
  Args: {
    stackedTabs?: string;
  };
  Blocks: {
    default: [
      {
        'menu-tab': typeof AditoolsMenuTab;
      },
    ];
  };
}
export default class AditoolsMenuTabs extends Component<AditoolsMenuTabsSignature> {
  menuTabClass = AditoolsMenuTab;
  get _stackedTabs() {
    return this.args.stackedTabs ?? false;
  }
}
